/**
 * @file 落地页 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import {fetchGetPaddleInfo} from '../../api/pages/paddleApi';
import {IBannerData, IPageDataItem} from './types';

// 从 url 中解析本页数据关联的key
const getParamsFromUrl = () => {
    const pathDetailUrl = window.location.pathname;
    const theUrlSearchs = new URLSearchParams(window.location.search.slice(1));
    const searchDetailUrl = theUrlSearchs.get('detailUrl');
    const requestUrl = searchDetailUrl || pathDetailUrl || undefined;

    return {
        requestUrl
    };
};


// 预请求
let preRequest: any = {};
if (window) {
    const serverRenderData = (window as any).serverRenderData;
    if (serverRenderData) {
        preRequest.fetchGetPaddleInfo = Promise.resolve({body: serverRenderData});
    }
    else {
        preRequest.fetchGetPaddleInfo = fetchGetPaddleInfo(getParamsFromUrl());
    }
}

const usePaddle = () => {
    const [bannerData, setBannerData] = useState<IBannerData | undefined>();
    const [pageData, setPageData] = useState<IPageDataItem[]>([]);

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetPaddleInfo || fetchGetPaddleInfo(getParamsFromUrl());
            delete preRequest.fetchGetModelInfo;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const result = res.body.result;
                const thePageData: any[] = result.pageData;
                if (Array.isArray(thePageData)) {
                    // banner
                    const bannerObj = thePageData.find(
                        item => item.name === 'paddlePictureBanner'
                    );
                    if (bannerObj && bannerObj.options) {
                        const theOptions = bannerObj.options;
                        const theBtns: any[] = theOptions.btns || [];
                        setBannerData({
                            btns: theBtns.map(item => ({
                                title: item.title,
                                link: item.link,
                                target: item.target
                            })),
                            subtitle: theOptions.subtitle,
                            title: theOptions.title
                        });
                    }

                    const restPageData = thePageData.filter(
                        item => item.name !== 'paddlePictureBanner'
                    );

                    setPageData(restPageData);
                }
            }
        })();
    }, []);

    return {
        bannerData,
        pageData
    };
};

// const usePaddleHooks = () => {
//     const {
//         bannerData,
//         pageData
//     } = usePaddle();
//
//     return {
//         bannerData,
//         pageData
//     };
// };

export default usePaddle;
